import { TabList as MuiTabList, TabListProps as MuiTabListProps } from "@mui/lab";
import { styled } from "@mui/material";

const StyledTabList = styled(MuiTabList)(() => ({
  // ... existing styles
}));

interface TabListProps extends MuiTabListProps {
  children: React.ReactNode;
}

export const TabList: React.FC<TabListProps> = ({ children, ...props }) => {
  return (
    <StyledTabList
      TabIndicatorProps={{
        style: {
          backgroundColor: "#FFD400",
        },
      }}
      {...props}
    >
      {children}
    </StyledTabList>
  );
};

export default TabList;
